import { Component } from '@angular/core';
import { SessionService } from '@app/shared/services/session.service';

@Component({
    selector: 'app-public-layout',
    templateUrl: './public-layout.component.html',
    styleUrls: ['./public-layout.component.scss'],
    standalone: false
})
export class PublicLayoutComponent {
  constructor(public session: SessionService) {}
}
